"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
/* eslint-disable react/prop-types */
/** @jsx jsx */
const core_1 = require("@emotion/core");
const Sentry = __importStar(require("@sentry/browser"));
const logrocket_1 = __importDefault(require("logrocket"));
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const browser_version_1 = __importDefault(require("@/components/browser-version"));
const modals_1 = require("@/modals");
const config_1 = __importDefault(require("../config"));
const context_1 = require("./context");
const styled_react_1 = __importDefault(require("./styled-react"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
class App extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign(Object.assign({}, context_1.initialValues), { closeNav: () => {
                this.setState({
                    navOpen: false,
                });
            }, openNav: () => {
                this.setState({
                    navOpen: true,
                });
            } });
    }
    componentDidMount() {
        if (config_1.default.sentry) {
            Sentry.init({ dsn: config_1.default.sentry.token });
        }
        if (config_1.default.logrocket) {
            logrocket_1.default.init(config_1.default.logrocket.token, { release: config_1.default.version });
            if (config_1.default.sentry) {
                Sentry.configureScope((scope) => {
                    scope.addEventProcessor((eventData) => __awaiter(this, void 0, void 0, function* () {
                        const newData = Object.assign({}, eventData);
                        newData.extra.sessionURL = logrocket_1.default.sessionURL;
                        return newData;
                    }));
                });
            }
        }
    }
    render() {
        const { children } = this.props;
        const { navOpen } = this.state;
        return ((0, core_1.jsx)(context_1.AppContext.Provider, { value: this.state },
            (0, core_1.jsx)("div", { className: styles_scss_1.default.appContainer, css: styled_react_1.default.isViewingMobileNav(navOpen) },
                (0, core_1.jsx)("div", { className: styles_scss_1.default.main },
                    (0, core_1.jsx)(components_1.Header, null),
                    (0, core_1.jsx)(browser_version_1.default, null),
                    (0, core_1.jsx)("div", { className: styles_scss_1.default.content }, children))),
            (0, core_1.jsx)(components_1.Modal
            // @ts-ignore
            , { 
                // @ts-ignore
                modals: {
                    [modals_1.ModalNames.USER_CANCEL_SUBSCRIPTION]: ({ content }) => content[modals_1.ModalNames.USER_CANCEL_SUBSCRIPTION] || (0, core_1.jsx)("div", null),
                    [modals_1.ModalNames.ORIGINAL_CANCEL_SUBSCRIPTION]: ({ content }) => content[modals_1.ModalNames.ORIGINAL_CANCEL_SUBSCRIPTION] || (0, core_1.jsx)("div", null),
                    [modals_1.ModalNames.SUBSCRIPTION_SUCCESS]: ({ content }) => content[modals_1.ModalNames.SUBSCRIPTION_SUCCESS] || (0, core_1.jsx)("div", null),
                    [modals_1.ModalNames.CHOOSE_WALLET]: ({ content }) => content[modals_1.ModalNames.CHOOSE_WALLET] || (0, core_1.jsx)("div", null),
                } }),
            (0, core_1.jsx)(components_1.Version, { version: config_1.default.version })));
    }
}
exports.App = App;
exports.default = App;
